export const menu = styles => ({
    ...styles,
    borderRadius: '6px',
    width: 'auto',
});

export const menuList = (styles, state, menuHeight) => ({
    ...styles,

    borderRadius: '6px',
    maxHeight: menuHeight,

    '::-webkit-scrollbar': {
        width: '5px',
    },

    '::-webkit-scrollbar-track': {
        background: 'transparent',
    },

    '::-webkit-scrollbar-thumb': {
        background: '#d6dadc',
        borderRadius: '4px',
    },

    '::-webkit-scrollbar-thumb:hover': {
        background: '#d6dadc',
    },

});

export const option = (styles, state, fontColor, minWidth, whiteSpace) => ({
    ...styles,
    backgroundColor: state.isSelected ? 'rgba(0, 0, 0, 0.14)' : '#ffffff',
    color: '#555555',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 'calc(100% - 1px)',
    minWidth,
    whiteSpace: whiteSpace || 'nowrap',

    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        cursor: 'pointer',
    },

    '@media(max-width: 480px)': {
        whiteSpace: 'normal',
    },
});
